export default __webpack_public_path__ + "static/media/manager-photo.dd8cf954.png";